module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-5 darker"
  }, [_c('h5', {
    staticClass: "d-flex flex-grow justify-content-between  align-items-center w-100"
  }, [_c('span', [_vm._v("Integrate services with your Pluralo account.")]), _vm._v(" "), _c('input', {
    staticClass: "btn widest ml-auto",
    attrs: {
      "type": "submit",
      "value": "Save"
    },
    on: {
      "click": _vm.save
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "my-4"
  }, [_vm._v("\n        Here you can connect other services to augment your experience.\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mb-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Stripe API - Publishable key\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.presets.stripeApiKey_Public),
      expression: "presets.stripeApiKey_Public"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.presets.stripeApiKey_Public)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.presets, "stripeApiKey_Public", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mb-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Stripe API - Secret key\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.presets.stripeApiKey_Secret),
      expression: "presets.stripeApiKey_Secret"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.presets.stripeApiKey_Secret)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.presets, "stripeApiKey_Secret", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mb-1 pt-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 d-flex justify-content-between"
  }, [_c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('h2', [_vm._v("Invoicing")]), _vm._v(" "), (_vm.presets.hasInvoiceSystem == false) ? _c('span', {
    staticClass: "dark bold fs-small",
    on: {
      "click": _vm.addInvoiceObject
    }
  }, [_vm._v("Integrate your invoicing software with Pluralo.")]) : _vm._e()]), _vm._v(" "), (_vm.presets.hasInvoiceSystem == false) ? _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('button', {
    staticClass: "btn blue",
    on: {
      "click": _vm.activateInvoicing
    }
  }, [_vm._v("Activate")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 mb-4"
  }, [(_vm.presets.hasInvoiceSystem && _vm.presets.hasInvoiceSystem == true) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "full d-flex justify-content-between w-100"
  }, [_vm._v("\n                        Enabled\n                        "), _c('toggle-button', {
    attrs: {
      "value": true,
      "sync": true,
      "labels": {
        checked: 'YES',
        unchecked: 'NO'
      }
    },
    model: {
      value: (_vm.presets.invoiceSystem.isActive),
      callback: function($$v) {
        _vm.$set(_vm.presets.invoiceSystem, "isActive", $$v)
      },
      expression: "presets.invoiceSystem.isActive"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        Software\n                    ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.invoiceSoftwares,
      "disabled": _vm.diabledInvoiceInputs,
      "label": "name"
    },
    model: {
      value: (_vm.selectedInvoiveIntegrationOption),
      callback: function($$v) {
        _vm.selectedInvoiveIntegrationOption = $$v
      },
      expression: "selectedInvoiveIntegrationOption"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        Get Article URL\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.presets.invoiceSystem.primaveraGetArticlesURL),
      expression: "presets.invoiceSystem.primaveraGetArticlesURL"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text",
      "disabled": _vm.diabledInvoiceInputs
    },
    domProps: {
      "value": (_vm.presets.invoiceSystem.primaveraGetArticlesURL)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.presets.invoiceSystem, "primaveraGetArticlesURL", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        Post Invoice URL\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.presets.invoiceSystem.primaveraPostInvoiceURL),
      expression: "presets.invoiceSystem.primaveraPostInvoiceURL"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text",
      "disabled": _vm.diabledInvoiceInputs
    },
    domProps: {
      "value": (_vm.presets.invoiceSystem.primaveraPostInvoiceURL)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.presets.invoiceSystem, "primaveraPostInvoiceURL", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        Get Invoice Credit Note URL\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.presets.invoiceSystem.primaveraGetInvoiceCreditNoteURL),
      expression: "presets.invoiceSystem.primaveraGetInvoiceCreditNoteURL"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text",
      "disabled": _vm.diabledInvoiceInputs
    },
    domProps: {
      "value": (_vm.presets.invoiceSystem.primaveraGetInvoiceCreditNoteURL)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.presets.invoiceSystem, "primaveraGetInvoiceCreditNoteURL", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                        Get Invoice Document URL\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.presets.invoiceSystem.primaveraGetInvoiceDocumentURL),
      expression: "presets.invoiceSystem.primaveraGetInvoiceDocumentURL"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text",
      "disabled": _vm.diabledInvoiceInputs
    },
    domProps: {
      "value": (_vm.presets.invoiceSystem.primaveraGetInvoiceDocumentURL)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.presets.invoiceSystem, "primaveraGetInvoiceDocumentURL", $event.target.value)
      }
    }
  })])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-right"
  }, [_c('input', {
    staticClass: "btn widest ml-auto",
    attrs: {
      "type": "submit",
      "value": "Save"
    },
    on: {
      "click": _vm.save
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8 mb-1"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 d-flex flex-row align-items-center justify-content-between"
  }, [_c('div', {
    staticClass: "row w-100"
  }, [_c('div', {
    staticClass: "col-sm-10"
  }, [_c('h2', [_vm._v("Stripe")])])])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-fe11233e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe11233e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/TabIntegrations.vue
// module id = 1586
// module chunks = 0